import { render, staticRenderFns } from "./NewSupplierAdd.vue?vue&type=template&id=c61e6732&scoped=true"
import script from "./NewSupplierAdd.vue?vue&type=script&lang=js"
export * from "./NewSupplierAdd.vue?vue&type=script&lang=js"
import style0 from "./NewSupplierAdd.vue?vue&type=style&index=0&id=c61e6732&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c61e6732",
  null
  
)

export default component.exports